"use client";
import { cn } from "@/lib/utils";
import { MenuIcon } from "lucide-react";
import Link from "next/link";
import * as React from "react";
import { Button } from "./ui/button";
import { Dialog, DialogClose } from "./ui/dialog";
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
} from "./ui/navigation-menu";
// import ModeToggle from "../mode-toggle"
import { usePathname } from "next/navigation";
import ModeToggle from "./mode-toggle";
import {
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";

export function NavBar() {
  const navItems = [
    { name: "Our Services", href: "/#services" },
    { name: "Case Studies", href: "/projects" },
    { name: "Contact", href: "/contact" },
  ];
  const pathname = usePathname();

  return (
    <div className='fixed z-[50] mt-[2rem] flex w-full min-w-full items-center justify-center p-2'>
      <div className='relative flex w-[95%] justify-between rounded-xl border border-white border-opacity-20 bg-white bg-opacity-10 p-2 shadow-lg backdrop-blur-lg backdrop-filter dark:border-zinc-900 dark:bg-black md:w-[720px]'>
        <Dialog>
          <div className='flex w-full justify-between md:hidden'>
            <span className='md:hidden'>
              <ModeToggle />
            </span>
            <SheetTrigger className='ml-auto p-2 transition min-[825px]:hidden'>
              <MenuIcon />
            </SheetTrigger>
          </div>
          <SheetContent side='right'>
            <SheetHeader>
              <SheetTitle>RolexStudio.works</SheetTitle>
            </SheetHeader>
            <div className='z-[99] mt-[1rem] flex flex-col space-y-3'>
              <DialogClose asChild>
                <Link href='/'>
                  <Button variant='outline' className='w-full'>
                    Home
                  </Button>
                </Link>
              </DialogClose>
              <DialogClose asChild>
                <Link href='/#services'>
                  <Button variant='outline' className='w-full'>
                    Our Services
                  </Button>
                </Link>
              </DialogClose>
              <DialogClose asChild>
                <Link href='/projects'>
                  <Button variant='outline' className='w-full'>
                    Case Studies
                  </Button>
                </Link>
              </DialogClose>
              <DialogClose asChild>
                <Link href='/contact'>
                  <Button variant='outline' className='w-full'>
                    Get Free Month
                  </Button>
                </Link>
              </DialogClose>
            </div>
          </SheetContent>
        </Dialog>
        <NavigationMenu>
          <NavigationMenuList className='max-[825px]:hidden'>
            <Link href='/' className='pl-2'>
              <h1 className='font-bold'>RolexStudio.works</h1>
            </Link>
          </NavigationMenuList>
        </NavigationMenu>
        <div className='flex items-center gap-2 max-[825px]:hidden'>
          {navItems.map((item) => (
            <Link key={item.href} href={item.href}>
              <Button
                variant='ghost'
                className={
                  pathname === item.href
                    ? "bg-accent font-semibold text-primary"
                    : ""
                }
              >
                {item.name}
              </Button>
            </Link>
          ))}
          <ModeToggle />
        </div>
      </div>
    </div>
  );
}

const ListItem = React.forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className
          )}
          {...props}
        >
          <div className='text-sm font-medium leading-none'>{title}</div>
          <p className='line-clamp-2 text-sm leading-snug text-muted-foreground'>
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";
